import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";

function Router({ children, basename }) {
    return <BrowserRouter basename={basename}>{children}</BrowserRouter>;
}

Router.propTypes = {
    children: PropTypes.node.isRequired,
    basename: PropTypes.string,
};

Router.defaultProps = {
    basename: "/",
};

export default Router;
